import {
    EMAIL_CHANGED,
    PASSWORD_CHANGED,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAIL,
    LOGIN_USER,
    LOGOUT_USER,
    SIGNATURE_CLEARED,
    UPDATE_USER_INFO,
    UPDATE_ADDRESS_INFO,
    UPDATE_HEALTH_SYSTEM_INFO,
    UPDATE_HEALTH_ACTIVITY_INFO,
    UPDATE_BANK_INFO,
    UPDATE_TECHNICAL_CONFIG,
    UPDATE_GLOBAL_CONFIG,
} from '../actions/types'

interface AuthStore {
    email: string
    password: string
    user: any
    bankInfo: any
    address: any
    extraHealthSystemInfo: any
    extraHealthActivityInfo: any
    allQualification: Array<any>
    qualification: any
    allProfession: Array<any>
    profession: any
    allSpeMention: Array<any>
    speMention: Array<any>
    allSpeciality: Array<any>
    speciality: any
    error: string
    loading: boolean
    technicalConfig: any
    globalConfig: any
    runConformity: boolean
    securedEmail: any
    administrativeEmail: any
}

const INITIAL_STATE: AuthStore = {
    email: '',
    password: '',
    user: null,
    bankInfo: null,
    address: null,
    extraHealthSystemInfo: null,
    extraHealthActivityInfo: null,
    allQualification: [],
    qualification: null,
    allProfession: [],
    profession: null,
    allSpeMention: [],
    speMention: [],
    allSpeciality: [],
    speciality: null,
    error: '',
    loading: true,
    technicalConfig: null,
    globalConfig: null,
    runConformity: false,
    securedEmail: null,
    administrativeEmail: null,
}

export default (state = INITIAL_STATE, action: any): AuthStore => {
    switch (action.type) {
        case EMAIL_CHANGED:
            return {
                ...state,
                email: action.payload,
            }
        case PASSWORD_CHANGED:
            return {
                ...state,
                password: action.payload,
            }
        case LOGIN_USER:
            return {
                ...state,
                loading: true,
                error: '',
            }
        case LOGIN_USER_SUCCESS:
            return {
                ...state,
                ...INITIAL_STATE,
                ...action.payload,
                loading: false,
            }
        case LOGIN_USER_FAIL:
            return {
                ...state,
                error: 'Mauvais email ou mot de passe',
                password: '',
                loading: false,
            }
        case LOGOUT_USER:
            return {
                ...state,
                ...INITIAL_STATE,
                loading: false,
            }
        case SIGNATURE_CLEARED:
            return {
                ...state,
                extraHealthSystemInfo: {
                    ...state.extraHealthSystemInfo,
                    signature: '',
                },
            }
        case UPDATE_USER_INFO:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload,
                },
            }
        case UPDATE_ADDRESS_INFO:
            return {
                ...state,
                address: {
                    ...state.address,
                    ...action.payload,
                },
            }
        case UPDATE_HEALTH_SYSTEM_INFO:
            return {
                ...state,
                extraHealthSystemInfo: {
                    ...state.extraHealthSystemInfo,
                    ...action.payload,
                },
            }
        case UPDATE_HEALTH_ACTIVITY_INFO:
            return {
                ...state,
                ...action.payload,
            }
        case UPDATE_TECHNICAL_CONFIG:
            return {
                ...state,
                technicalConfig: action.payload.value,
            }
        case UPDATE_GLOBAL_CONFIG:
            return {
                ...state,
                technicalConfig: action.payload,
            }
        case UPDATE_BANK_INFO:
            return {
                ...state,
                bankInfo: {
                    ...state.bankInfo,
                    ...action.payload,
                },
            }
        default:
            return state
    }
}
